export default {
  IN_PROGRESS: 'IN_PROGRESS',
  ACTIVE: 'ACTIVE',
} as const
